import script from "./LastTickets.vue?vue&type=script&lang=ts&setup=true"
export * from "./LastTickets.vue?vue&type=script&lang=ts&setup=true"

import "./LastTickets.vue?vue&type=style&index=0&id=63afcf80&lang=scss"

const __exports__ = script;

export default __exports__